import _ from "lodash";
import moment from "moment";
import sign from 'jwt-encode';
import helper from './helper'
import { v4 as uuidv4 } from 'uuid';
import CONFIGLIFF from '../configLiffNew.json'
export default {
  CONFIG: {
    //  CONFIG API
    version: 'P.1.0.0',
    DEVTOOL: false,
    BASEFE: 'https://dev-nurse.scapp.work',
    // MOCKLINEID: getQueryParams()?.sub ?? "U6d6ade8591201befc6dbe257838fcf52",

    //  CONFIG GENARAL
    MAXSIZEFILE: 1024000,
    IMGTYPEFILE: ['image/png', 'image/jpeg', 'image/jpg'],
    RESUMEMAXSIZEFILE: 10485760,
    RESUMETYPEFILE: ['application/pdf', 'image/jpeg', 'image/jpg'],
    MONTH: {
      1: "มกราคม",
      2: "กุมภาพันธ์",
      3: "มีนาคม",
      4: "เมษายน",
      5: "พฤษภาคม",
      6: "มิถุนายน",
      7: "กรกฎาคม",
      8: "สิงหาคม",
      9: "กันยายน",
      10: "ตุลาคม",
      11: "พฤศจิกายน",
      12: "ธันวาคม"
    },
    MONTH_NO: {
      "มกราคม": "01",
      "กุมภาพันธ์": "02",
      "มีนาคม": "03",
      "เมษายน": "04",
      "พฤษภาคม": "05",
      "มิถุนายน": "06",
      "กรกฎาคม": "07",
      "สิงหาคม": "08",
      "กันยายน": "09",
      "ตุลาคม": "10",
      "พฤศจิกายน": "11",
      "ธันวาคม": "12"
    },
    MONTH_ENTOTH: {
      "January": "มกราคม",
      "February": "กุมภาพันธ์",
      "March": "มีนาคม",
      "April": "เมษายน",
      "May": "พฤษภาคม",
      "June": "มิถุนายน",
      "July": "กรกฎาคม",
      "August": "สิงหาคม",
      "September": "กันยายน",
      "October": "ตุลาคม",
      "November": "พฤศจิกายน",
      "December": "ธันวาคม",
    },
    MONTHARRAY: [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ],
  },
  getLiffIdByENV: (path, env = 'dev') => {
    if (process.env.REACT_APP_ENV) {
      env = process.env.REACT_APP_ENV
    }
    console.log('env >>', env)
    console.log('CONFIGLIFF[env] >>', CONFIGLIFF[env])
    if (CONFIGLIFF[env][path]) {
      console.log('path >>', path)
      return CONFIGLIFF[env][path]
    } else {
      for (const p in CONFIGLIFF[env]) {
        if (`${path}`.startsWith(p)) {
          return CONFIGLIFF[env][p]
        }
      }
    }
    
    if(CONFIGLIFF[env]['default']) {
      return CONFIGLIFF[env]['default']
    } 

    return "null"
  },
  GEN: {
    OPTION_YEAR: () => {
      const startYear = 2022
      const endYear = Number(moment().format('YYYY'))
      let option = []
      for(let i = 0; startYear + i <= endYear; i++) {
        option.push(`${startYear + i}`)
      }
      return option
    },
    toValueHeader: (props) => {
      return { lineId: props.user?.lineId?.lineId, memberId: Number(props.user?.lineId?.memberId) }
    },
    toHeader: (header = { lineId:  getQueryParams()?.sub , memberId: null }) => {
      const secret = 'nurse';
      const data = header;
      const jwt = sign(data, secret);
      console.log('jwt >>', jwt);
      const token = jwt
      return {
        Authorization: `Bearer ${token}`
      }
    },
    queryCache: () => {
      const uuid = uuidv4();
      return `?cache=${uuid}`
    }
  },
  CKFORM: {
    cardID: (value = '') => {
      if (value.length < 17) {
        // console.log('value >>', value)
        // console.log('value length >>', value.length)
        return true
      }
      return false
    },
    textLen: (value = '', max = 10) => {
      if (value.length < max) {
        // console.log('value >>', value)
        // console.log('value length >>', value.length)
        return true
      }
      return false
    }
  },
  TIME: {
    disableDate: (date, minDate = null, maxDate = null) => {
      const curDate = moment(moment(date).format('YYYY-MM-DD 00:00:00'))
  
      if (minDate) {
          minDate = moment(minDate,'YYYY-MM-DD 00:00:00')
      }
      if (maxDate) {
          maxDate = moment(maxDate,'YYYY-MM-DD 00:00:00')
      }
  
      if (minDate && maxDate) {
          if (curDate.diff(minDate,'day') >= 0 && curDate.diff(maxDate,'day') <= 0) {
              return false
          }
          return true
  
      }
      else if (minDate) {
          if (curDate.diff(minDate,'day') >= 0) {
              return false
          }
          return true
      }
      else if (maxDate) {
          if (curDate.diff(maxDate,'day') <= 0) {
              return false
          }
          return true
      }
      return false
    }
  },
  FN: {
    numberToshift: (shift) => {
      const shiftName = {
        1: 'กะเช้า',
        2: 'กะกลางวัน',
        3: 'กะดึก',
      }
      return shiftName[shift]
    },
    shiftToNumber: (shiftCode = '') => {
      if (`${shiftCode}`.indexOf('D') !== -1) {
        return 1
      }
      if (`${shiftCode}`.indexOf('P') !== -1) {
        return 2
      }
      if (`${shiftCode}`.indexOf('N') !== -1) {
        return 3
      }
      return null
    },
    monthTHYearToNumber: (monthThYear = '') => {
      const [ month, year ] = monthThYear.split(' ')
      if(helper.CONFIG.MONTH_NO[month]) {
        return year + '-' + helper.CONFIG.MONTH_NO[month]
      }
      return null
    },
    toDateFullThai: (date) => {
      const DD = moment(date).format('DD')
      const MMMM = moment(date).format('M')
      const YYYY = moment(date).format('YYYY')
      return `${DD} ${helper.CONFIG.MONTH[MMMM]} ${YYYY}`
    },
    toTimeHM: (date) => {
      return moment(date,'HH:mm:ss').format('HH.mm')
    },
    toTimeHMC: (date) => {
      return moment(date,'HH:mm:ss').format('HH:mm')
    },
    toNumberWithCommas: (x = '') => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toArrayNumber: (arr = []) => {
      return arr.map(item => Number(item)).filter(item => item)
    },
    numberWithZero: (num = '', pad = 4) => {
      var str = "" + num
      var padStr = ""
      for(let i = 0; i < pad; i++) {
        padStr += "0"
      }
      return padStr.substring(0, padStr.length - str.length) + str
    }
  },

  SORT: {
    compare: (a, b, key) => {
      if ( _.get(a,key) < _.get(b,key) ){
        return -1;
      }
      if ( _.get(a,key) > _.get(b,key) ){
        return 1;
      }
      return 0;
    },
  }
};

function getQueryParams() {
  var queryString = window.location.search;

  queryString = queryString.substring(1);
  var queryParams = queryString.split('&');
  var params = {};

  queryParams.forEach(function(param) {
    var keyValue = param.split('=');
    var key = decodeURIComponent(keyValue[0]);
    var value = decodeURIComponent(keyValue[1] || '');

    params[key] = value;
  });

  return params;
}
